export default __webpack_public_path__ + "static/media/icon_grid.53616ee8.svg";